import type { CourseWithoutBlocks } from '@/types/course'
import { useReorderLessonsMutation } from '@/features/editor/lessonsApi'
import { useSaveStatusWrap } from '@/features/editor/hooks/useSaveStatusWrap'
import { buildLessonUpdate } from '@/features/editor/lib/buildLessonUpdate'
import { computeReorderUpdates } from '@/features/editor/lib/orderUtils'
import { refusedByReview } from '@/features/editor/lib/reviewGuard'
import { useIsCourseFrozen } from '@/features/moderation/useCourseModeration'
import { messagesNow } from '@/i18n'
import { messages } from './messages'

export const useLessonReorder = (course: CourseWithoutBlocks) => {
  const wrap = useSaveStatusWrap()
  const [reorderLessons] = useReorderLessonsMutation()
  const isFrozen = useIsCourseFrozen(course.id)

  return (fromIndex: number, toIndex: number) => {
    if (refusedByReview(isFrozen)) return
    const updates = computeReorderUpdates(course.lessons, fromIndex, toIndex).map((u) => ({
      id: u.item.id,
      order: u.order,
      // Full body: backend PUT resets missing fields (see buildLessonUpdate).
      patch: buildLessonUpdate(u.item, { order: u.order }),
    }))
    if (updates.length === 0) return
    void wrap(
      reorderLessons({ courseId: course.id, updates }).unwrap(),
      messagesNow(messages).reorderLessonsFailed,
    )
  }
}
